<template>
  <div>
    <v-select
      v-show="isMobile"
      v-model="active[0]"
      :items="foldersFormattedForMobile"
      item-text="name"
      item-value="id"
      return-object
      solo
      outlined
      dense
      prepend-inner-icon="mdi-folder-open-outline"
    >
      <template v-slot:item="{ item }">
        <span :class="item.styleRule ? 'font-weight-bold' : null">{{
          item.name
        }}</span
        ><v-badge
          :content="item.badgeContent"
          :value="Boolean(item.badgeContent)"
          color="error"
          inline
        ></v-badge>
      </template>
    </v-select>
    <v-row>
      <v-col v-show="!isMobile" cols="12" sm="3">
        <v-treeview
          :items="folders"
          :active.sync="active"
          :open.sync="open"
          activatable
          open-on-click
          return-object
        >
          <template v-slot:prepend="{ item }">
            <v-icon v-if="!item.children">
              {{
                active[0] && active[0].id === item.id
                  ? "mdi-folder-open-outline"
                  : "mdi-folder-outline"
              }}
            </v-icon>
          </template>
          <template v-slot:label="{ item }">
            <span :class="item.styleRule ? 'font-weight-medium' : null">{{
              item.name
            }}</span
            ><v-badge
              :content="item.badgeContent"
              :value="Boolean(item.badgeContent)"
              color="error"
              bordered
            ></v-badge> </template></v-treeview
      ></v-col>
      <v-divider vertical></v-divider>
      <v-col cols="12" sm="9">
        <component
          v-if="active.length > 0"
          :is="active[0].component"
          :clientId="Boolean(client) ? client.clientId : null"
          :isServiceCoordination="active[0].name == 'SC Notes'"
          :notes="
            active[0].name == 'SC Notes'
              ? serviceCoordinationNotes
              : active[0].name == 'Session Notes'
              ? sessionNotes
              : null
          "
          :ageCategory="active[0].ageCategory"
      /></v-col>
    </v-row>
  </div>
</template>

<script>
import NotesTable from "./notes-table";
import GapsInService from "./gaps-in-service";
import ProgressReports from "./progress-reports";
import InPersonLogs from "./in-person-logs";
import OtherDocuments from "./other-documents.vue";

export default {
  props: ["client"],
  data() {
    return {
      active: [],
      open: [],
    };
  },
  components: {
    NotesTable,
    GapsInService,
    ProgressReports,
    InPersonLogs,
    OtherDocuments,
  },
  mounted() {
    var folder = this.folders.find(
      (item) => item.name == this.client?.currentAgeCategory
    );
    if (Boolean(folder)) {
      this.open.push(folder);
      this.active.push(folder.children[0]);
    } else {
      this.open.push(this.folders[0]);
      this.active.push(this.folders[0].children[0]);
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    folders() {
      var folders = [
        {
          id: 0,
          name: "Underschool",
          children: [
            {
              id: 1,
              name: "SC Notes",
              showTab: !this.isProvider, //SEITAdmin/EIAdmin/ServiceCoordinator can always view
              styleRule: Boolean(this.serviceCoordinationNotes.length),
              badgeContent: this.numAwaitingSCSignature,
              component: "NotesTable",
            },
            {
              id: 2,
              name: "Session Notes",
              showTab: this.isEIAdmin || Boolean(this.client), // EIAdmin can always view and anyone can view when within Client Chart
              styleRule: Boolean(this.sessionNotes.length),
              badgeContent: this.numAwaitingSupervisorSignature,
              component: "NotesTable",
            },
            {
              id: 3,
              name: "Gaps in Service",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.gapsInService.length),
              badgeContent: null,
              component: "GapsInService",
            },
            {
              id: 4,
              name: "Progress Reports",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.progressReports("Underschool").length),
              badgeContent: null,
              component: "ProgressReports",
              ageCategory: "Underschool",
            },
            {
              id: 5,
              name: "In Person Logs",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.inPersonLogs.length),
              badgeContent: null,
              component: "InPersonLogs",
            },
            {
              id: 6,
              name: "Other Documents",
              showTab: !this.isProvider && Boolean(this.client), //SEITAdmin/EIAdmin/ServiceCoordinator can view when within Client Chart
              styleRule: Boolean(this.documents("Underschool").length),
              badgeContent: null,
              component: "OtherDocuments",
              ageCategory: "Underschool",
            },
          ],
        },
        {
          id: 7,
          name: "Preschool",
          children: [
            {
              id: 8,
              name: "Progress Reports",
              showTab: Boolean(this.client), //anyone can view when within Client Chart
              styleRule: Boolean(this.progressReports("Preschool").length),
              badgeContent: null,
              component: "ProgressReports",
              ageCategory: "Preschool",
            },
            {
              id: 9,
              name: "Other Documents",
              showTab: !this.isProvider && Boolean(this.client), //SEITAdmin/EIAdmin/ServiceCoordinator can view when within Client Chart
              styleRule: Boolean(this.documents("Preschool").length),
              badgeContent: null,
              component: "OtherDocuments",
              ageCategory: "Preschool",
            },
          ],
        },
      ];
      return folders
        .map((parent) => ({
          ...parent,
          children: parent.children.filter((child) => child.showTab),
        }))
        .filter((parent) => parent.children.length > 0);
    },
    foldersFormattedForMobile() {
      var array = [];
      this.folders.map((x) => {
        array.push({ header: x.name });
        array.push(...x.children);
      });
      return array;
    },
    serviceCoordinationNotes() {
      return this.$store.state.clientModule.serviceCoordinationNotes;
    },
    sessionNotes() {
      return this.$store.state.clientModule.sessionNotes;
    },
    gapsInService() {
      return this.$store.state.clientModule.gapsInService ?? [];
    },
    inPersonLogs() {
      return this.$store.state.clientModule.inPersonLogs ?? [];
    },
    numAwaitingSCSignature() {
      return this.serviceCoordinationNotes.filter(
        (item) => item.providerId === this.providerId && !item.scSignatureId
      ).length;
    },
    numAwaitingSupervisorSignature() {
      return this.sessionNotes.filter(
        (item) =>
          item.supervisorId === this.providerId && !item.supervisorSignatureId
      ).length;
    },
    isEIAdmin() {
      return this.$store.getters["securityModule/isEIAdmin"];
    },
    isProvider() {
      return this.$store.getters["securityModule/isProvider"];
    },
    providerId() {
      return this.$store.state.sharedModule.providerId;
    },
  },
  methods: {
    progressReports(ageCategory) {
      return this.$store.getters[
        "clientModule/getProgressReportsForAgeCategory"
      ](ageCategory);
    },
    documents(ageCategory) {
      return this.$store.getters["clientModule/getDocumentsForAgeCategory"](
        ageCategory
      );
    },
  },
};
</script>